<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="请购单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入请购单号查询" v-model="queryParam.billNo"></a-input>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="12" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <section>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
            <template slot="expandedRowRender" slot-scope="record">
              <div v-for="item in record.items" :key="item.itemId" class="pending-item-row">
                {{ item.materialName }} × {{ item.operNumber }}{{ item.materialUnit || '' }}
                <span v-if="item.defaultSupplierName" class="default-supplier-tip">（默认归属：{{ item.defaultSupplierName }}）</span>
              </div>
            </template>
            <span slot="action" slot-scope="text, record">
              <template v-if="btnEnableList.indexOf(1)>-1">
                <a @click="handleAssign(record)">分配</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确认整单标记自采？将不生成采购订单。" @confirm="handleSelfPick(record)">
                  <a>标记自采</a>
                </a-popconfirm>
              </template>
              <span v-else>-</span>
            </span>
          </a-table>
        </section>
        <a-pagination
          style="margin-top: 16px; text-align: right"
          :current="ipagination.current"
          :pageSize="ipagination.pageSize"
          :total="ipagination.total"
          @change="paginationChange"
          @showSizeChange="paginationShowSizeChange"
        />
        <a-modal
          :title="assignTitle"
          :visible="assignVisible"
          :confirmLoading="assignLoading"
          :maskClosable="false"
          width="760px"
          @ok="handleAssignOk"
          @cancel="assignVisible = false">
          <a-table
            size="small"
            bordered
            rowKey="itemId"
            :columns="assignColumns"
            :dataSource="assignItems"
            :pagination="false">
            <template slot="supplierSelect" slot-scope="text, item">
              <a-select
                v-model="item.supplierId"
                showSearch
                optionFilterProp="children"
                placeholder="请选择供应商"
                style="width: 260px">
                <a-select-option v-for="supplier in itemOptions(item)" :key="supplier.id" :value="supplier.id">
                  {{ supplier.supplierName }}
                </a-select-option>
              </a-select>
            </template>
          </a-table>
          <div style="margin-top: 12px">
            <a-checkbox v-model="assignSetDefault">设为默认归属（同类请购单后续自动拆分到该供应商）</a-checkbox>
          </div>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getPendingAssign, assignPurchaseSplit, selfPickPurchaseSplit, getSupplierArchives } from '@/api/plugin/orderReceive'

export default {
  name: 'PendingAssignList',
  mixins: [JeecgListMixin],
  data() {
    return {
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 17,
        offset: 1
      },
      urlPath: '/plugin/order-receive/center/pending',
      queryParam: {
        billNo: ''
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '请购单号',
          dataIndex: 'billNo',
          width: 180
        },
        {
          title: '请购时间',
          dataIndex: 'operTime',
          width: 160
        },
        {
          title: '商品数',
          dataIndex: 'itemCount',
          width: 90,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/plugin/order-receive/purchase-split/pending'
      },
      assignTitle: '分配供应商',
      assignVisible: false,
      assignLoading: false,
      assignRecord: null,
      assignItems: [],
      assignSetDefault: true,
      supplierArchives: [],
      assignColumns: [
        {
          title: '商品名称',
          dataIndex: 'materialName',
          width: 220
        },
        {
          title: '数量',
          dataIndex: 'operNumber',
          width: 110,
          align: 'right',
          customRender: function(text, record) {
            return text + (record.materialUnit || '')
          }
        },
        {
          title: '供应商',
          dataIndex: 'supplierId',
          scopedSlots: { customRender: 'supplierSelect' }
        }
      ]
    }
  },
  methods: {
    getQueryParams() {
      return {
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        billNo: this.queryParam.billNo
      }
    },
    loadSupplierArchives() {
      getSupplierArchives().then((res) => {
        if (res.code === 200) {
          this.supplierArchives = res.data || []
        }
      })
    },
    handleAssign(record) {
      if (this.supplierArchives.length === 0) {
        this.loadSupplierArchives()
      }
      this.assignRecord = record
      // 预填：优先默认归属，其次唯一候选；候选来自商品已配的供应商集合
      this.assignItems = (record.items || []).map(item => {
        const candidateSuppliers = this.parseSupplierOptions(item.supplierOptions)
        return Object.assign({}, item, {
          candidateSuppliers: candidateSuppliers,
          supplierId: item.defaultSupplierId || (candidateSuppliers.length === 1 ? candidateSuppliers[0].id : undefined)
        })
      })
      this.assignSetDefault = true
      this.assignTitle = '分配供应商 - ' + record.billNo
      this.assignVisible = true
    },
    /** 明细供应商下拉选项：有候选（商品已配归属）用候选，否则全部供应商档案 */
    itemOptions(item) {
      return item.candidateSuppliers && item.candidateSuppliers.length ? item.candidateSuppliers : this.supplierArchives
    },
    /** 解析后端 supplierOptions（"id:名称,id:名称"）为候选列表 */
    parseSupplierOptions(options) {
      const result = []
      if (!options) {
        return result
      }
      String(options).split(',').forEach(part => {
        const idx = part.indexOf(':')
        if (idx > 0) {
          const id = Number(part.substring(0, idx))
          const name = part.substring(idx + 1)
          if (id > 0 && name) {
            result.push({ id: id, supplierName: name })
          }
        }
      })
      return result
    },
    handleAssignOk() {
      if (this.assignItems.length === 0) {
        this.$message.warning('该请购单无有效明细')
        return
      }
      if (this.assignItems.some(item => !item.supplierId)) {
        this.$message.warning('请为所有明细选择供应商')
        return
      }
      this.assignLoading = true
      assignPurchaseSplit({
        extId: this.assignRecord.id,
        qgdHeadId: this.assignRecord.qgdHeadId,
        setDefault: this.assignSetDefault,
        items: this.assignItems.map(item => {
          return { itemId: item.itemId, supplierId: item.supplierId }
        })
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message || '分配成功')
          this.assignVisible = false
          this.loadData()
        } else {
          this.$message.warning(res.message || '分配失败')
        }
      }).finally(() => {
        this.assignLoading = false
      })
    },
    handleSelfPick(record) {
      selfPickPurchaseSplit({
        extId: record.id,
        itemIds: (record.items || []).map(item => item.itemId)
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message || '已标记自采')
          this.loadData()
        } else {
          this.$message.warning(res.message || '标记自采失败')
        }
      })
    },
    paginationChange(current, pageSize) {
      this.ipagination.current = current
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, pageSize) {
      this.ipagination.current = 1
      this.ipagination.pageSize = pageSize
      this.loadData()
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
.pending-item-row { line-height: 24px; }
.default-supplier-tip { color: #888; }
</style>
